import { useAtom } from 'jotai';
import SummaryRiskCard from './SummaryRiskCard';
import FindingList from './FindingList';
import { severityFilterAtom, minConfidenceFilterAtom } from '@/hooks/atoms';
import type { ReportSummary, Severity } from '@/types/forensics';
import { Separator } from '@/components/ui/separator';

const SEVERITY_OPTIONS: { value: Severity | ''; label: string }[] = [
  { value: '', label: 'All' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
  { value: 'info', label: 'Info' },
];

interface FindingsTabProps {
  summary: ReportSummary | null;
}

export default function FindingsTab({ summary }: FindingsTabProps) {
  const [severityFilter, setSeverityFilter] = useAtom(severityFilterAtom);
  const [minConfidence, setMinConfidence] = useAtom(minConfidenceFilterAtom);

  return (
    <div className="space-y-4">
      {summary && <SummaryRiskCard summary={summary} />}

      <Separator />

      {/* Filters */}
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-1.5">
          <label className="text-xs font-medium text-muted-foreground">Severity:</label>
          <select
            value={severityFilter || ''}
            onChange={(e) => setSeverityFilter((e.target.value as Severity) || null)}
            className="text-xs border rounded px-2 py-1 bg-background"
          >
            {SEVERITY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-1.5">
          <label className="text-xs font-medium text-muted-foreground">Min confidence:</label>
          <input
            type="range"
            min={0}
            max={100}
            value={minConfidence * 100}
            onChange={(e) => setMinConfidence(Number(e.target.value) / 100)}
            className="w-20 h-1.5"
          />
          <span className="text-xs text-muted-foreground w-8">{Math.round(minConfidence * 100)}%</span>
        </div>
      </div>

      <FindingList />
    </div>
  );
}
